export default "/_next/static/5e5893ff602486ccefe5f22cfabc1a9b.jpg";